<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <app-table
          hide-upsert
          :config="config"
          title="Landing Page"
          @update="update"
          @link="link"
        >
          <template slot="headerActions">
            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <v-btn v-on="on" color="secondary" @click="newEntity()">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>New Landing Page</span>
            </v-tooltip>
          </template>
        </app-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import config from "./config_index.js";
import store from '../../store'
import { mapActions } from "vuex";

export default {
  data() {
    return {
      config,
    };
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    ...mapActions("app", ["getConfig"]),
    update(item) {
      this.$router.push("/landingpage/" + item.id);
    },
    newEntity() {
       this.$router.push("/landingpage");
    },
    link(item) {
        window.open(store.getters.siteUrl + '/landing/' + item.url, '_blank')
    }
  },
};
</script>
